import Vue from 'vue';

// Domain
import {
  InvestmentProductsStateManager,
} from '@/modules/flagship/catalogs/investment-products/domain/state/investment-products-state-manager';
import InvestmentProductsState
  from '@/modules/flagship/catalogs/investment-products/domain/state/investment-products-state';
import Injectable from '@/modules/shared/domain/di/injectable';
import Observer from '@/modules/shared/domain/observer/observer';

@Injectable()
export default class InvestmentProductsVueStateManager implements InvestmentProductsStateManager {
  // eslint-disable-next-line max-len
  private _state: InvestmentProductsState = Vue.observable<InvestmentProductsState>(new InvestmentProductsState());

  private readonly observers: Observer[] = [];

  get state(): InvestmentProductsState {
    return this._state;
  }

  set state(value: InvestmentProductsState) {
    this._state = value;
    this.notifyAll();
  }

  patch(state: Partial<InvestmentProductsState>) {
    type Keys = keyof InvestmentProductsState;
    Object.entries(state).forEach(([key, value]) => {
      const accessor = key as Keys;

      if (value !== undefined) {
        // eslint-disable-next-line
        // @ts-ignore @typescript-eslint/ban-ts-ignore
        this.state[accessor] = value;
      }
    });
  }

  notifyAll() {
    this.observers.forEach((observer) => observer.notify());
  }

  register(observer: Observer) {
    this.observers.push(observer);
  }
}
